import { render, staticRenderFns } from "./FileUploadSettings.vue?vue&type=template&id=b96321ac&scoped=true"
import script from "./FileUploadSettings.vue?vue&type=script&lang=ts"
export * from "./FileUploadSettings.vue?vue&type=script&lang=ts"
import style0 from "./FileUploadSettings.vue?vue&type=style&index=0&id=b96321ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96321ac",
  null
  
)

export default component.exports